var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "message_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#message_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.842 5.024A4.492 4.492 0 0 1 6 2.25h6c2.485 0 4.5 2.021 4.5 4.496v9.004H6a4.504 4.504 0 0 1-4.5-4.495v-4.51c0-.59.116-1.175.342-1.721ZM15 6.746a3.003 3.003 0 0 0-3-2.996H6a2.992 2.992 0 0 0-3 2.996v4.508a3.003 3.003 0 0 0 3 2.996h9V6.746ZM12 8.25v1.5h-1.5v-1.5H12Zm-4.5 0v1.5H6v-1.5h1.5Z",
    fill: "#fff"
  }))));
};

export default SvgMessage;